export class PessoaJuridica {
  ativo: boolean;
  id: number;
  cnpj: string;
  email: string;
  razaoSocial: string;
  telefone: string;
  nomeFantasia: string;
  enderecoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/shared/pessoa-juridica.model.ts
 **/